import React, { useState, useEffect } from 'react';
import packageJson from '../package.json';
import Ok from './components/Dialog/Ok';
import Circular from 'components/Progress/Circular';
global.appVersion = packageJson.version;

const CacheBuster = ({ children }) => {
  const [updateRequired, setUpdateRequired] = React.useState(null);
  const [dialog, showDialog] = useState(false);

  const semverGreaterThan = (versionA, versionB) => {
    const versionsA = versionA.split(/\./g);

    const versionsB = versionB.split(/\./g);
    while (versionsA.length || versionsB.length) {
      const a = Number(versionsA.shift());

      const b = Number(versionsB.shift());
      // eslint-disable-next-line no-continue
      if (a === b) continue;
      // eslint-disable-next-line no-restricted-globals
      return a > b || isNaN(b);
    }
    return false;
  };
  const handleOk = () => {
    if (caches) {
      // Service worker cache should be cleared with caches.delete()
      caches.keys().then(function (names) {
        for (let name of names) caches.delete(name);
      });
    }
    // delete browser cache and hard reload
    window.location.reload(true);
  };

  useEffect(() => {
    if (navigator.onLine) {
      fetch('/meta.json' + `?time=${Date.now()}`)
        .then((response) => response.json())
        .then((meta) => {
          const latestVersion = meta.version;
          const currentVersion = global.appVersion;
          const shouldForceRefresh = semverGreaterThan(
            latestVersion,
            currentVersion
          );
          if (shouldForceRefresh) {
            showDialog(meta);
          } else {
            setUpdateRequired(false);
          }
        });
    } else setUpdateRequired(false);
  }, []);

  return (
    <React.Fragment>
      {dialog !== false && (
        <Ok
          title="بروزرسانی ضروری"
          text="کاربر گرامی، نسخه جدیدتری از اپلیکیشن موجود است. اپلیکیشن بصورت خودکار بروزرسانی میشود."
          onClose={handleOk}
        >
          <div className="d-flex my-2 flex-column" style={{ gap: 8 }}>
            <b>{`نسخه جدید ورژن ${dialog?.version} منتشر شد!`}</b>
            <ul>
              {dialog?.logs?.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>
        </Ok>
      )}
      {updateRequired === null && (
        <div className="d-flex justify-content-center align-item-center">
          <Circular />
        </div>
      )}
      {updateRequired === false && children}
    </React.Fragment>
  );
};

export default React.memo(CacheBuster);
